import React, { FunctionComponent } from 'react'

import { CancellationConfig } from '../../../../state/configuration'
import { CancellationCoolingOffPage } from './CancellationCoolingOffPage'
import { CancellationStandardPage } from './CancellationStandardPage'

export interface CancellationPageProps {
  config: CancellationConfig
}

export const CancellationPage: FunctionComponent<CancellationPageProps> = ({
  config,
}) => {
  switch (config.type) {
    case 'Standard':
      return <CancellationStandardPage config={config} />
    case 'CoolingOff':
      return <CancellationCoolingOffPage config={config} />
  }
}
